import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import jsPDF from 'jspdf';
import { FaDownload, FaEye, FaTimes } from 'react-icons/fa';
import * as API from "../Endpoints/Endpoints";

function ViewSdgBot() {
  const [bot, setChatbots] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [viewOpen, setViewOpen] = useState(false);
  const [viewLoading, setViewLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const modalRef = useRef(null);

  useEffect(() => {
    const fetchbot = async () => {
      try {
        const response = await axios.get(API.GET_SDG_API);
        setChatbots(response.data);
      } catch (error) {
        console.error('Error fetching sdgs:', error);
        toast.error('Failed to fetch SDG records');
      }
    };
    fetchbot();
  }, []);

  useEffect(() => {
    if (viewOpen && modalRef.current) {
      setTimeout(() => {
        try { modalRef.current.scrollTop = 0; } catch (e) {}
      }, 0);
    }
  }, [viewOpen]);

  const filteredBots = bot.filter((item) => {
    const q = (searchQuery || '').toLowerCase();
    return (
      item.useremail?.toLowerCase().includes(q) ||
      item.organizationname?.toLowerCase().includes(q) ||
      item.sdgtitle?.toLowerCase().includes(q) ||
      item.sdgdescription?.toLowerCase().includes(q) ||
      item.sdgproblem?.toLowerCase().includes(q) ||
      item.sdgsolution?.toLowerCase().includes(q) ||
      item.sdgframework?.toLowerCase().includes(q) ||
      item.sdgbenificiaries?.toLowerCase().includes(q) ||
      item.sdgstakeholder?.toLowerCase().includes(q) ||
      item.sdgsoftware?.toLowerCase().includes(q) ||
      item.sdgalignment?.toLowerCase().includes(q) ||
      item.sdgschedule?.toLowerCase().includes(q) ||
      item.sdgimpact?.toLowerCase().includes(q) ||
      item.sdgtechnologies?.toLowerCase().includes(q) ||
      item.sdgsteam?.toLowerCase().includes(q)
    );
  });

  const handleView = async (item) => {
    try {
      setViewLoading(true);
      setViewOpen(true);
      setSelected(null);

      const res = await axios.get(API.GET_SDG_API);
      const rec = res.data.find((r) => r.sdgid === item.sdgid);
      if (!rec) {
        toast.error('Record not found');
        setViewOpen(false);
        return;
      }
      setSelected(rec);
    } catch (err) {
      console.error(err);
      toast.error('Failed to load details');
      setViewOpen(false);
    } finally {
      setViewLoading(false);
    }
  };

  const handleImport = (item) => {
    const doc = new jsPDF();
    let yPosition = 20;
    const lineHeight = 10;
    const maxWidth = 180;
    const pageHeight = doc.internal.pageSize.height;

    const addText = (text, x, y) => {
      const safe = String(text ?? '');
      const splitText = doc.splitTextToSize(safe, maxWidth);
      doc.text(splitText, x, y);
      return splitText.length * lineHeight;
    };

    const checkAndAddPage = (currentYPosition) => {
      if (currentYPosition + lineHeight > pageHeight) {
        doc.addPage();
        return 20;
      }
      return currentYPosition;
    };

    const addHeading = (heading, x, y) => {
      doc.setFont('helvetica', 'bold');
      y += addText(heading, x, y);
      doc.setFont('helvetica', 'normal');
      return y;
    };

    yPosition = addHeading(`Organization name:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.organizationname, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`User email:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.useremail, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Title:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.sdgtitle, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Description:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.sdgdescription, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Problems:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.sdgproblem, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Solution:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.sdgsolution, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Logical Framework:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.sdgframework, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Beneficiaries:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.sdgbenificiaries, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Stakeholder:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.sdgstakeholder, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Software Recommendation:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.sdgsoftware, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`SDG Goal Alignment:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.sdgalignment, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Schedule:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.sdgschedule, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Impact:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.sdgimpact, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`Recommended Technologies:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.sdgtechnologies, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    yPosition = addHeading(`STEAM Theory:`, 10, yPosition);
    yPosition = checkAndAddPage(yPosition);
    yPosition += addText(item.sdgsteam, 10, yPosition);
    yPosition = checkAndAddPage(yPosition + lineHeight);

    doc.save(`${(item.sdgtitle || 'sdg')}.pdf`);
  };

  return (
    <div className="container mx-auto px-4 mt-10">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">SDG References</h1>
        <input
          type="text"
          placeholder="Search..."
          className="px-4 py-2 border rounded-md"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border-gray-300 shadow-md rounded-md table-fixed">
          <colgroup>
            <col style={{ width: '6%' }} />
            <col style={{ width: '4%' }} />
            <col />
          </colgroup>

          <thead className="bg-gray-800 text-white">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold">Actions</th>
              <th className="px-4 py-3 text-left text-sm font-semibold">Sr No</th>
              <th className="px-4 py-3 text-left text-sm font-semibold">Title</th>
            </tr>
          </thead>

          <tbody>
            {filteredBots.map((item, index) => (
              <tr key={item.sdgid || index} className="border-b align-top">
                <td className="px-4 py-3 whitespace-normal">
                  <div className="flex items-center gap-2">
                    <button
                      className="text-indigo-600 hover:underline flex items-center gap-1"
                      onClick={() => handleView(item)}
                      title="View"
                    >
                      <FaEye />
                    </button>

                    <button
                      className="text-blue-500 hover:underline flex items-center gap-1"
                      onClick={() => handleImport(item)}
                      title="Export as PDF"
                    >
                      <FaDownload />
                    </button>

                    {/* Uncomment/add edit/delete components if available:
                        <EdituserSDG sdgid={item.sdgid} refreshList={refreshList} />
                        <DeleteuserSDG sdgid={item.sdgid} refreshList={refreshList} />
                    */}
                  </div>
                </td>

                <td className="px-4 py-3 whitespace-normal text-sm">{index + 1}</td>

                <td className="px-4 py-3 whitespace-normal text-sm break-words max-w-[420px]">
                  {item.sdgtitle || 'Untitled'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* VIEW MODAL */}
      {viewOpen && (
        <div className="fixed inset-0 z-50 flex items-start sm:items-center justify-center bg-black/50 p-4">
          <div
            ref={modalRef}
            className="bg-white w-full max-w-5xl rounded-2xl shadow-xl p-6 relative overflow-y-auto max-h-[90vh]"
          >
            <button
              className="absolute top-4 right-4 text-gray-600 hover:text-black"
              onClick={() => { setViewOpen(false); setSelected(null); }}
              aria-label="Close"
            >
              <FaTimes />
            </button>

            {viewLoading ? (
              <div className="py-20 text-center">Loading...</div>
            ) : selected ? (
              <>
                <div id="pdf-like" className="border rounded-xl p-6 bg-white">
                  <div className="mb-1 text-2xl font-semibold break-words">
                    {selected.sdgtitle || 'Untitled SDG'}
                  </div>
                  <div className="text-sm text-gray-600 mb-4">
                    {selected.useremail ? `By ${selected.useremail}` : ''} {selected.organizationname ? `• ${selected.organizationname}` : ''}
                  </div>

                  <PdfSection title="Description" text={selected.sdgdescription} />
                  <PdfSection title="Problems" text={selected.sdgproblem} />
                  <PdfSection title="Solution" text={selected.sdgsolution} />
                  <PdfSection title="Logical Framework" text={selected.sdgframework} />
                  <PdfSection title="Beneficiaries" text={selected.sdgbenificiaries} />
                  <PdfSection title="Stakeholder" text={selected.sdgstakeholder} />
                  <PdfSection title="Software Recommendation" text={selected.sdgsoftware} />
                  <PdfSection title="SDG Goal Alignment" text={selected.sdgalignment} />
                  <PdfSection title="Schedule" text={selected.sdgschedule} />
                  <PdfSection title="Impact" text={selected.sdgimpact} />
                  <PdfSection title="Recommended Technologies" text={selected.sdgtechnologies} />
                  <PdfSection title="STEAM Theory" text={selected.sdgsteam} />
                </div>

                <div className="mt-6 flex justify-end">
                  <button
                    className="px-6 py-2 bg-gray-600 text-white rounded-lg shadow hover:bg-gray-700"
                    onClick={() => { setViewOpen(false); setSelected(null); }}
                  >
                    Back
                  </button>
                </div>
              </>
            ) : (
              <div className="py-20 text-center text-red-600">No record found.</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function PdfSection({ title, text }) {
  if (!text) return null;
  return (
    <div className="mt-5">
      <h3 className="text-lg font-semibold border-b border-gray-200 pb-1">{title}</h3>
      <div className="mt-2 whitespace-pre-wrap leading-relaxed text-gray-800 break-words">
        {text}
      </div>
    </div>
  );
}

export default ViewSdgBot;
